import { app } from "@/app.js";
import { useStore } from "@/Stores/domain";
import { useForm } from "./form";

export function login(form) {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await form.post("auth_login");
            // app.config.globalProperties.$app.authenticated = true;
            // const store = useStore();
            // await store.fetchDomain();
            // app.config.globalProperties.$app.domain = store.domain;
            resolve();
        } catch (err) {
            console.error("Caught an error during login:", err);
            reject(err);
        }
    });
}

export function logout() {
    return new Promise(async (resolve, reject) => {
        try {
            await useForm().post("auth_logout");
            app.config.globalProperties.$app.authenticated = false;
            const store = useStore();
            store.$reset();
            resolve();
        } catch (err) {
            console.error("Caught an error during logout:", err);
            reject(err);
        }
    });
}

export function isLoggedIn() {
    return app.config.globalProperties.$app.authenticated;
}

export function isTrialEnded() {
    if (app.config.globalProperties.$app.domain?.is_premium) {
        return false;
    }

    return app.config.globalProperties.$app.domain?.user.trial.status === "ended";
}
